import script from "./Activity_List.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_List.vue?vue&type=script&setup=true&lang=js"

import "./Activity_List.vue?vue&type=style&index=0&id=64869e35&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64869e35"]])

export default __exports__